/**
 * Session app-data for Enterprise salon customer flow.
 * Single master public_token is used across the whole salon experience.
 *   /enterprise/salon/session/master-token
 *   /enterprise/salon/session/app-data/<token>/...
 * Dev: setupProxy.js → localhost:5013 /session/...
 */
import { resolveExperienceHubPath } from '../utils/salonHomeNav';

export const SESSION_APP_DATA_BASE = '/enterprise/salon/session/app-data';
/** Public singleton master token (used across all Enterprise salon pages). */
export const SESSION_MASTER_TOKEN_URL = '/enterprise/salon/session/app-data/-/public-token';

/**
 * Default home for salon mid-flow: Welcome hub landing.
 * Skin-analysis Home clears guest state then navigates here for a new user.
 */
export function getSessionLandingPath(_token) {
  return resolveExperienceHubPath();
}
